import { Component, EventEmitter, Input, Output, OnChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-alert-detalhe-rota',
    templateUrl: './alert-detalhe-rota.component.html',
    styleUrls: ['./alert-detalhe-rota.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertDetalheRotaComponent implements OnChanges {

  @Input() alertDetalheRota: boolean = false;
  @Input() dadosRota: any = null;
  @Output() alertRotaFechou = new EventEmitter();

  constructor() { }

  ngOnChanges(changes: any) {
    if(this.dadosRota) {
      localStorage.setItem('dadosRotaHtml', this.dadosRota);
      document.querySelector('#content').innerHTML = localStorage.getItem('dadosRotaHtml');
    }
  }

  fecharModalRota() { this.alertRotaFechou.emit('Fechou'); }

  imprimirRota(){
    let WinPrint = window.open('', '', 'width=640,height=auto');
    WinPrint.document.body.innerHTML = localStorage.getItem('dadosRotaHtml');
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  }
}
